// Copyright 2020 TOKU Systems Inc.

import { DomainTuple } from 'victory-core';
import moment from 'moment';

export interface PlotDomain {
  x: DomainTuple;
  y: DomainTuple;
}

export function plotDuration(): moment.Duration {
  return moment.duration('P30D');
}

export function makeTimeDomain(props: {
  start?: moment.Moment;
  end?: moment.Moment;
}): DomainTuple {
  let start: moment.Moment;
  let end: moment.Moment;

  if (props.start) {
    start = props.start.clone().utc().startOf('second');
    end = start.clone().add(plotDuration());
  } else {
    end = props.end?.clone().utc() ?? moment().utc().startOf('second');
    start = end.clone().subtract(plotDuration());
  }

  return [start.valueOf(), end.valueOf()];
}

export function lastDay(time: DomainTuple): DomainTuple {
  return [
    moment(time[1].valueOf()).subtract(1, 'day').valueOf(),
    time[1].valueOf(),
  ];
}
